import Index from "../../pages/snail/riverMountain-2/index";

const base = "riverMountain-2";

const routes = [
  {
    path: `/${base}/index`,
    name: `${base}-index`,
    component: Index
  },
  {
    path: `/${base}/enter*`,
    name: `${base}-enter`,
    component: Index
  }
];

export default routes;



// WEBPACK FOOTER //
// ./src/router/snail/riverMountain-2.js